export default __webpack_public_path__ + "static/ayana-147beb54c58d16993ebfe27b76f6929e.png";